import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/lib/motion";

/**
 * Reveal — fades + slides children up when scrolled into view.
 * Accepts optional delay and custom variant.
 */
export const Reveal = ({ children, delay = 0, className = "", as = "div", variants = fadeUp, ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      transition={{ delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
